import {Card, CardContent, CardDescription, CardHeader, CardTitle, SsoConnector} from "@tinct/web-components";
import {InfoIcon} from "lucide-react";
import {ReadUser} from "@tinct/core-api-models";
import {GoogleLogo, LinkedInLogo, MicrosoftLogo} from "../../../../shared";

export const SsoConnectSection = ({user}: {user: ReadUser}) => {

  // Get connected identifiers from user's socialIdentifiers
  const socialIdentifiers = user?.socialIdentifiers ?? {};
  const googleEmail = socialIdentifiers['google'] ?? null;
  const linkedInId = socialIdentifiers['linkedin'] ?? null;
  const microsoftId = socialIdentifiers['microsoft'] ?? null;

  const handleConnect = (provider: string) => {
    // TODO: Implement OAuth connection flow
    console.log(`Connect to ${provider}`);
  };

  const handleDisconnect = (provider: string) => {
    // TODO: Implement disconnect flow
    console.log(`Disconnect from ${provider}`);
  };

  return <div className="flex gap-8 hidden">
    {/* Main content */}
    <Card className="flex-1 rounded-2xl basis-1/2">
      <CardHeader className="border-b">
        <CardTitle className="text-xl">Connected accounts</CardTitle>
        <CardDescription>
          Manage third-party services you use to log in to your Tinct account
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-4 pt-6">
        <SsoConnector
          logo={<GoogleLogo />}
          providerName="Google"
          isConnected={!!googleEmail}
          identifier={googleEmail ?? undefined}
          onConnect={() => handleConnect('google')}
          onDisconnect={() => handleDisconnect('google')}
        />
        <SsoConnector
          logo={<LinkedInLogo />}
          providerName="LinkedIn"
          isConnected={!!linkedInId}
          identifier={linkedInId ?? undefined}
          onConnect={() => handleConnect('linkedin')}
          onDisconnect={() => handleDisconnect('linkedin')}
        />
        <SsoConnector
          logo={<MicrosoftLogo />}
          providerName="Microsoft"
          isConnected={!!microsoftId}
          identifier={microsoftId ?? undefined}
          onConnect={() => handleConnect('microsoft')}
          onDisconnect={() => handleDisconnect('microsoft')}
        />
      </CardContent>
    </Card>

    {/* Info sidebar */}
    <div className="w-80 shrink-0 basis-1/2">
      <div className="self-stretch px-4 py-3 bg-card rounded-[10px] border inline-flex justify-start items-center gap-3">
        <InfoIcon className="size-5 shrink-0 text-muted-foreground" />
        <p className="text-sm text-muted-foreground">
          You can connect multiple accounts. At least one account must remain
          connected to access Tinct. Otherwise, opt for the email - password
          option and set a password below.
        </p>
      </div>
    </div>
  </div>
}
